<!-- src/components/projects/Summary.vue -->
<template>
  <div>
    <h2>Bem-vindo à Página Inicial!</h2>
    <p>Aqui você pode gerenciar seus locais, ambientes, caixas e quadros.</p>
  </div>
</template>

<script>
export default {};
</script>
